/**
* FeedbackContent.js
* 
* Created on Oct 23, 2013, 3:33:30 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/

import Content from "./Content";
import ENGLanguagePackContentType from "./ENGLanguagePackContentType";

export default class FeedbackContent extends Content {
    constructor(languagePack, contentID, eventName, eventType, eventDescription, image, movie, label) {
        super(FeedbackContent.NAME, FeedbackContent.TYPE, label, languagePack, contentID);
    }

    setImage(value) {
        this.setLanguagePackText(FeedbackContent.IMAGE_LABEL, value);
    }

    getImage() {
        return this.getLanguagePackContent(FeedbackContent.IMAGE_LABEL, ENGLanguagePackContentType.TEXT);
    }

    getMovie(value) {
        this.setLanguagePackText(FeedbackContent.MOVIE_LABEL, value);
    }

    setMovie() {
        return this.getLanguagePackContent(FeedbackContent.MOVIE_LABEL, ENGLanguagePackContentType.TEXT);
    }

    getName() {
        return this.getLanguagePackContent(FeedbackContent.FEEDBACK_NAME_LABEL, ENGLanguagePackContentType.TEXT);
    }

    setName(value) {
        this.setLanguagePackText(FeedbackContent.FEEDBACK_NAME_LABEL, value);
    }

    getFeedbackName() {
        return this.getLanguagePackContent(FeedbackContent.FEEDBACK_NAME_LABEL, ENGLanguagePackContentType.TEXT);
    }

    setFeedbackName(value) {
        this.setLanguagePackText(FeedbackContent.FEEDBACK_NAME_LABEL, value);
    }

    getFeedbackType() {
        return this.getLanguagePackText(FeedbackContent.FEEDBACK_TYPE_LABEL);
    }

    setFeedbackType(value) {
        this.setLanguagePackText(FeedbackContent.FEEDBACK_TYPE_LABEL, value);
    }

    getFeedbackDescription() {
        return this.getLanguagePackText(FeedbackContent.FEEDBACK_DESCRIPTION_LABEL);
    }

    setFeedbackDescription(value) {
        this.setLanguagePackText(FeedbackContent.FEEDBACK_DESCRIPTION_LABEL, value);
    }

    convertToObject() {
        return this.getObject([]);
    }
}

FeedbackContent.NAME = "Feedback";
FeedbackContent.TYPE = "engFeedbackContent";
FeedbackContent.IMAGE_LABEL = "image";
FeedbackContent.MOVIE_LABEL = "movie";

FeedbackContent.FEEDBACK_NAME_LABEL = "feedbackName";
FeedbackContent.FEEDBACK_TYPE_LABEL = "feedbackType";
FeedbackContent.FEEDBACK_DESCRIPTION_LABEL = "feedbackDescription";